import { createRouter, createWebHashHistory } from 'vue-router'

const files = require.context('@/view', true, /\.vue$/)
let views = {}
let viewsfile = []
files.keys().forEach(key => {
  let routekey = key.substring(2)
  let newkey = routekey.slice(0, -4)
  viewsfile.push(newkey)
  views[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default
})

let routes = []
Object.keys(views).forEach((item, index) => {
  routes.push({
    path: `/${views[item].name.replace(/-/g, '/')}${views[item].name.includes('audioDetail') ? '/:id' : ''}`,
    name: views[item].name,
    meta: views[item].meta,
    component: () => import(`@/view/${viewsfile[index]}`)
  })
})

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
